import { useTranslation } from '@framework/i18n';
import { IISODateProps, ISODate } from '@framework/ui';
import React from 'react';
import styled from 'styled-components';

const TaskDateFromStyle = styled.span`
  font-size: ${props => props.theme.fontSizeSM}px;
  color: ${props => props.theme.colorTextSecondary};
  line-height: 1;
`;

export interface ITaskDateFromProps extends IISODateProps {
  text?: string;
}

/**
 * Visualizzazione data inizio attività per Mobile
 *
 */
export function TaskDateFrom(props: ITaskDateFromProps) {
  const { text, ...otherProps } = props;
  const { t } = useTranslation();

  return (
    <TaskDateFromStyle>
      {text ?? t('table.table-date-from.from', 'Dal')}{' '}
      <ISODate {...otherProps} />
    </TaskDateFromStyle>
  );
}
